module.exports = __webpack_public_path__ + "img/ISO27017.254e1df5.png";